export const api = {
    configuracion: "/api/recaudo/proyecto/cliente/opcion/consulta",
    token: "/api/recaudo/get/token",
    facturas: "/api/recaudo/proyecto/consultar/facturas",
    actualizacion: "/api/recaudo/proyecto/consultar/actualizacion/configuracion",
    exportar: "/api/recaudo/proyecto/export",
    aplicarPago: "/api/recaudo/proyecto/actualizar/pago/facturas",
    crearFacturaFormulario:"/api/recaudo/proyecto/crear/facturas/formulario",
    actualizarFacturaConfirmacion:"/api/recaudo/proyecto/actualizar/pago/facturas/confirmacion",
    validarPlan:"/api/recaudo/plan/validacion",
    facturasApi:"/api/recaudo/proyecto/api/consulta/facturas",
    crearFacturaOnline:"/api/recaudo/proyecto/crear/facturas/online",
    codigoPagoConsulta: "/api/recaudo/detalle_factura",
    validarPago: "/api/validate/payment",
    checkout: "/api/recaudo/checkout/session",
    sessionId: "/api/recaudo/checkout/sessionid",


};


export default {api};
